
















import { Component, Vue, Prop } from 'vue-property-decorator';
import { EventMealsModel } from '@/interfaces/registration/models/EventMealsModel';

@Component
export default class Meals extends Vue {
  @Prop({ default: () => { return {}; } }) readonly value!: EventMealsModel;
}
